import styled from 'styled-components';

export const ResearchProjectStyle = styled.div`
  position: relative;
  width: 100%;
  max-width: 72rem;
  margin: 0 auto;
  color: var(--ink);

  .project-header {
    width: 100%;
    padding-bottom: 24px;
    margin-bottom: 24px;
    border-bottom: 1px solid var(--line);

    .heading {
      display: block;
      font-size: 30px;
      line-height: 36px;
      font-weight: 800;
      letter-spacing: -0.025em;
      margin: 0 0 8px;
      text-transform: capitalize;
      color: var(--ink);
    }

    p {
      margin: 0;
      font-size: 15px;
      line-height: 22px;
      color: var(--quiet);
    }
  }

  .threads-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin: 0 0 20px;

    .title {
      display: block;
      font-size: 18px;
      line-height: 22px;
      font-weight: 700;
      margin: 0;
      color: var(--ink);
    }
  }

  .scroll-area {
    width: 100%;
  }

  .section-loader {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 220px;
    width: 100%;

    > div {
      min-height: 160px !important;
      height: auto !important;
      flex: 0 0 auto !important;
    }
  }

  .threads-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .no-threads {
    width: 100%;
    font-size: 14px;
    line-height: 22px;
    padding: 64px 24px;
    margin: 0;
    text-align: center;
    color: var(--quiet);
    border: 1px solid var(--line);
    border-radius: 22px;
    background: var(--card);
    box-shadow: var(--shadow);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .empty-icon {
      margin-bottom: 16px;
      color: var(--quiet);
    }

    p {
      margin: 0;
    }
  }
`;
